// extracted by mini-css-extract-plugin
export default {"wrapper":"DataModelConnectionRow_wrapper__gvzfq","dynamicPlaceholder":"DataModelConnectionRow_dynamicPlaceholder__1MtmQ"};